import React from "react";

export const AttachmentPopup = ({ setgetId, handleFileChange }) => {
  return (
    <div className="add-member">
      <button className="close-btn-pop close-member">
        <span
          className="material-symbols-outlined"
          onClick={() => setgetId(null)}
        >
          close
        </span>
      </button>
      <h4 className="mem-heading">Attach</h4>
      <form>
        <h3 className="bm-heading">Attach a file from your computer</h3>
        <p>You can also drag and drop files to upload them. </p>
        <div className="upload-btn-wrapper">
          <label for="fileAttachment" className="fileattach-label">
            Upload a file
          </label>
          <input
            type="file"
            id="fileAttachment"
            className="add-attachment"
            accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip, image/*"
            multiple
            onChange={handleFileChange}
          />
        </div>
      </form>
    </div>
  );
};
